import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import showDiv from '@ivy/fts/showDiv';
import agreementModal from './agreementModal.vue';
import { env } from '@ivy/fts/envInfo/envInfo';
let signPage = class signPage extends Vue {
    async created() {
        await env.init();
        const isLogin = await env.getIsLogin();
        if (!isLogin) {
            // 用户未注册
            return await env.login();
        }
        await showDiv(agreementModal, { hideBtn: true });
    }
};
signPage = tslib_1.__decorate([
    Component({})
], signPage);
export default signPage;
